// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2N8Sa","errorLogs":"EditorFooter_errorLogs__1b_Ey"};